var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 48 48",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#241F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.979 22h12v4h-12zM8.979 29h12v4h-12zM8.979 36h12v4h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.979 0h-30v48h30V18h14.043V0H31.979zm-4 44h-22V18h22v26zm0-30h-22V4h22v10zM37 11.422L33.086 6.62h7.83L37 11.422z"
  }))));
}

export default SvgDropdown;